import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Ows from "../../utils/OwsHandler";

interface VacancyState {
  vacancies: any[];
  loading: boolean;
  error: string | null;
}

const initialState: VacancyState = {
  vacancies: [],
  loading: false,
  error: null,
};

export const fetchVacancies = createAsyncThunk(
  "vacancies/fetch",
  async (vacancyUids: string[], { rejectWithValue }) => {
    try {
      const detailResponse = vacancyUids.map((uid) => ({
        method: "Otys.Services.VacancyService.getDetail",
        args: [uid, { uid: true, title: true, status: true }],
      }));
      
      const { response } = await Ows.handleMultiRequest(detailResponse);
      return response.map((vacancy) => ({
        uid: vacancy.data.uid,
        title: vacancy.data.title,
        status: vacancy.data.status,
      }));
    } catch (error) {
      return rejectWithValue("Failed to fetch vacancies.");
    }
  }
);

const vacancySlice = createSlice({
  name: "vacancies",
  initialState,
  reducers: {
    resetVacancies: (state) => {
      state.vacancies = [];
      state.loading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVacancies.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVacancies.fulfilled, (state, action) => {
        state.vacancies = action.payload;
        state.loading = false;
      })
      .addCase(fetchVacancies.rejected, (state, action) => {
        state.error = action.payload as string;
        state.loading = false;
      });
  },
});

export const { resetVacancies, clearError } = vacancySlice.actions;
export default vacancySlice.reducer;